import React from "react";

import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import  NuDropdown from "components/nubox/NuDropdown";


import NuConfirm from "components/nubox/Box/NuConfirm";

import { withRouterJim } from "router/withRouterJim";



import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const initialForm={
 
  id_carre: 0,
  
  id_peri:0,
  periodo:'',
}

/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class RepMateXCarrera extends React.Component {  

  modalRef = React.createRef();//create ref
  
  state = {
    modalInsertar: false,
    form: Object.assign({}, initialForm),
    data: [],/* lista  */
    carreras:[], //para combo
    
  };
  
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    //this.setState({fechai: defaultValue}); 
    this.setState({ form:{...this.state.form, fecha: defaultValue,}}); 

    //this.cargar_globalx();
    //const user = this.props.store.user
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;

    this.setState({ form:{...this.state.form, 
                            fecha: defaultValue,
                            id_peri: id_peri,
                            periodo: periodo,
                            }}); 
    this.cargar_carreras();
    //this.fetchData(this.state.fechai);
    console.log(this.modalRef);
  }

  //------------ cambiamos la fecha
  /*handleChange = event =>{
    this.setState({ name: event.target.value});
  }*/
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  
  
  //====================================================== 
  //----cargamos los datos desde la base de datos
  /*{
    "id_medico": 1,
        "nombre": "Dr. Gerson Abner Villafuerte Oporto",
        "dir": "",
        "tel": "",
        "cel": "",
        "foto_path1": ""
        "especialidad": "Ortodoncia"
  },*/
  //----cargamos combo
  cargar_carreras = async() => {
    let param = { }

    await axios2.post('cbo_carrera', param).then(res => {
        if(res.data.length>0){ 
            this.setState({carreras: res.data});
            this.setState({ form:{...this.state.form, 
                            id_carre: res.data[0].value}});
        }else{
          toast.error('No existen datos');
        }
    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
    });
  };
  //--------------------------------------------------
 
  
  /************************************************ */
  //-----------------------------------  
  imprimir =()=>{
    let param =  this.state.form;
    //param.idd =1;
    //param.ope ='e';
    let id_carre = this.state.form.id_carre;
    let id_peri = this.state.form.id_peri;
    console.log(param);

    let fileURL = process.env.REACT_APP_API_URL  + "rep_mate_x_carrera_pdf/"+ id_carre+"/"+id_peri;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  //----------------
  //-------------------------------------
  render() {
    
    return (
      <div>
        <ToastContainer />
        <div className="content">
        {
          //JSON.stringify( this.state.form )
        }
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                {/*<!-- -->*/}
                <div className="pull-left">
                    <h3>Reporte de materias por carrera</h3>
                </div>
                {/*<!-- -->*/}
                
            </div>
        </div>
        {/*<!--- ------------------------------->*/}
        <div className="row d-flex justify-content-center">
          <div className=" card " style={{width: 350 }}>
            <div className="card-body">
              <form >

                  <table className="tabla_basic">
                    <tbody>
                      <tr>
                        <td>Carrera:</td>
                        <td>
                          <NuDropdown
                            options={this.state.carreras}
                            name="id_carre"
                            value={this.state.form.id_carre}
                            onChange={this.handleChangeForm }
                          />
                        </td>

                        <td>

                        </td>
                      </tr>
                      {/*<!-- -->*/}
                     
                      <tr>
                        <td>Periodo:</td>
                        <td colspan="2">
                          <span>{ this.state.form.periodo} </span>
                        </td>
                        <td></td>
                      </tr>
                      
                      <tr>
                        <td colspan="3"><div id="divres1"></div></td>
                      </tr>
                    </tbody></table>


              </form>

            </div>

            <div className="card-footer text-center">
              <Button onClick={ this.imprimir } className="btn btn-success">
                <i className="fa fa-binoculars" aria-hidden="true"></i>
                Export PDF
              </Button>
            </div>
          </div>

        </div>



          {/*<!-- -------------------------------------------------->*/}

        </div>

      </div>
    );
  }
}
  
export default withRouterJim(RepMateXCarrera);